/**
 * For demo environment where rails must be in development mode,
 * removes autobuild minified errors
 * */
import Vue from 'vue'

const isAutobuild = import.meta.env.VITE_RUBY_AUTO_BUILD === 'true'
Vue.config.silent = isAutobuild
